import { useTranslate } from "@refinedev/core";
import { Flex, Popconfirm } from "antd";
import { CTAButton } from "../StoryboardMenuTabs/CTAButton";
import type { ItemType } from "../../types";

export enum ApplySettings {
  ALL = "all",
  SPECIFIC = "specific",
  NONE = "none",
}

export const ApplySettingsOptions = ({
  onChange,
  itemType,
  allSceneTypes = false,
}: {
  onChange: (value: ApplySettings) => void;
  itemType: ItemType["type"];
  allSceneTypes?: boolean;
}) => {
  const t = useTranslate();
  const titleKey = allSceneTypes
    ? "components.templates.settings.applySettings.allScenesTitle"
    : "components.templates.settings.applySettings.title";
  return (
    <Flex vertical gap={16}>
      <Popconfirm
        title={t("components.templates.TemplatesBoard.confirmTitle")}
        onConfirm={() => {
          onChange(ApplySettings.ALL);
        }}
      >
        <CTAButton>
          {t(titleKey, {
            item: t(
              `components.templates.settings.applySettings.items.${itemType}`
            ),
            type: t("components.templates.settings.applySettings.types.all"),
          })}
        </CTAButton>
      </Popconfirm>
      <CTAButton
        onClick={() => {
          onChange(ApplySettings.SPECIFIC);
        }}
      >
        {t(titleKey, {
          item: t(
            `components.templates.settings.applySettings.items.${itemType}`
          ),
          type: t("components.templates.settings.applySettings.types.specific"),
        })}
      </CTAButton>
    </Flex>
  );
};
